import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-etlfilters',
    templateUrl: './etlfilters.component.html',
    styleUrls: ['./etlfilters.component.scss'],
    standalone: false
})
export class EtlfiltersComponent implements OnInit {
  
  FormValid: UntypedFormGroup;
  backgroundColorScreen="";
  buttonColor="";
  allocateButtonsBoolean = false;
  allocateButtons1Boolean = false;
  backgroundColorButton = "";
  filterquery;
  validation_messages;

  constructor(private dialogref: MatDialogRef<EtlfiltersComponent>, private localStorageSettings: LocalStorageSettingsService, private msg: ErrorMessages) { 
    this.validation_messages = this.msg.etlTool;
  }

  ngOnInit() {

    this.formvalidation();
    
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);
  }

  formvalidation(){
    this.FormValid = new UntypedFormGroup({
      filterquery: new UntypedFormControl('', [Validators.required, Validators.maxLength(1000), Validators.minLength(10)])
    })
  }

  apply(){
    console.log(this.FormValid.value);
    // let result = this.FormValid.value.filterquery
    // let filter = result.filterquery;
    // alert(result);
    this.FormValid.reset();
  }

  cancel() {
     this.dialogref.close();
    }

}
